import { Component, Input, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresse } from '../models/TypeAdresse';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-type-adresse',
  templateUrl: './type-adresse.component.html'
})
export class TypeAdresseComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresse';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

  public paysCtrName: string;

  	@Input() adr: TypeAdresse;

    public step1 = new Step1();

    public optionsSelect: any[];
    public optionsSelectType = 'PAYS';
    public rg1 = CTRL_268.id + '_1';
    private destroy$ = new Subject<void>();

    constructor(private autoCompleteService: AutoCompleteService, private avisDataTransferService: AvisDataTransferService) { }

    public ngOnInit() {
      this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
      this.paysCtrName = this.getUid() + '_SepAtt_pays';

      if (!this.adr) {
        this.adr = new TypeAdresse();
      }
      if (this.adr.pays === null || this.adr.pays === 'FR') {
        this.adr.pays = '';
      }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const control = this.parentForm.get(this.paysCtrName);
      if (control) {
        control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
          if (this.adr) {
            this.adr.pays = value;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  isFr(): boolean {
    let paysCtrl = this.parentForm.controls[this.paysCtrName]?.value;
		if ( paysCtrl == undefined ? (this.adr.pays === '' || this.adr.pays === null || this.adr.pays === 'FR') : (paysCtrl === '' || paysCtrl === null || paysCtrl === 'FR') ) {
			this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_268Names_json() }));
      return true;
		}
		return false;
	}

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_DIVERS_SepSep_TypeAdresseCompleteObligatoire_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

}

